import { Box } from '@mui/material';
import { mainContentStyles } from './MainContentProps';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useGlobalOptions } from '../../hooks/useGlobalOptions';
import { useTabNavigation } from '../../store/mainTabsStore';
import { MainLink, MainLinks } from '../MainNavigation/MainNavigationUtils';

const staticLinksByUrl = new Map<string, MainLink>();
Object.values(MainLinks).forEach((link) => {
  if (link.url.includes(':') || staticLinksByUrl.has(link.url)) return;
  staticLinksByUrl.set(link.url, link);
});

const MainContent = () => {
  useGlobalOptions();
  const location = useLocation();
  const { syncActiveTabToRoute } = useTabNavigation();

  useEffect(() => {
    const link = staticLinksByUrl.get(location.pathname);
    if (!link) return;

    syncActiveTabToRoute(link.url, link.title);
  }, [location.pathname, syncActiveTabToRoute]);

  return (
    <Box sx={mainContentStyles}>
      <Outlet />
    </Box>
  );
};

export default MainContent;
